export const navstate = {
    namespaced : true,
    state: {
        selectedSection : null,
        globalOptions : [
            { title: 'Home', icon: 'mdi-home', to: '/' },
            { title: 'Add / Update Assets', icon: 'mdi-cloud-upload', to: '/addupdateassets' },
            { title: 'Attribute Manager', icon: 'mdi-link-variant', to: '/attributemanagement'},
            { title: 'Profile Manager', icon: 'mdi-account-group', to: '/profiles'},
            { title: 'Search Index', icon: 'mdi-database-sync', to: '/productsearchadmin'},
            {
                title: 'IXP Tools',
                icon: 'mdi-file-pdf-box',
                to: '/pdf2excel',
                subOptions: [
                    { title: 'PDF 2 Excel Tabular', icon: 'mdi-table', to: '/pdf2excel/tabular' },
                    { title: 'PDF 2 Excel Visual', icon: 'mdi-image', to: '/pdf2excel/visual' }
                ]
            }
        ],
        sectionOptions : [ ],
        drawOpen : false,
        clipboardText : null
    },
    mutations: {
        SetSelectedSection (state, sectionName)
        {
            state.selectedSection = sectionName;
            state.sectionOptions = [
                { title: 'Summary', icon: 'mdi-script-text', to:  '/section/' + encodeURI(sectionName)},
                { title: 'Catalogue', icon: 'mdi-magnify', to:  '/section/catalogue/' + encodeURI(sectionName)},
                { title: 'Search Assets', icon: 'mdi-magnify', to:  '/section/' + encodeURI(sectionName) + '/search'},
                { title: 'Asset Lists', icon: 'mdi-view-module', to:  '/section/' + encodeURI(sectionName) + '/lists'},
                { title: 'Add / Update Assets', icon: 'mdi-cloud-upload', to: '/section/addupdateassets/' + encodeURI(sectionName) },
            ]
            /*  
            state.sectionOptions = [
                { title: 'Summary', icon: 'mdi-script-text', to:  '/section/' + sectionName},
                { title: 'Search Assets', icon: 'mdi-magnify', to:  '/section/' + sectionName + '/search'},
                { title: 'Manage Attributes', icon: 'mdi-cogs', to: '' },
                { title: 'Report', icon: 'mdi-file-chart', to: '' }
            ]
            */
        },
        SetDrawerState(state, isOpen)
        {
            state.drawOpen = isOpen;
        },
        SetClipboardText (state, text)
        {
            state.clipboardText = text;
        }
    },
    actions: {
        GetSelectedSection ({commit},sectionName)
        {
            commit("SetSelectedSection", sectionName);
        },
        SetClipboardText ({commit},text)
        {
            commit("SetClipboardText", text);
        }
     
    },
    getters: {

    }
}
